import { Button, Drawer } from 'day8-ui';
import React from 'react';
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";
import { useInfoDrawer } from '../../context/InfoDrawerContext';
var InfoDrawer = function () {
    var _a = useInfoDrawer(), isModalOpen = _a.isModalOpen, modalProps = _a.modalProps, setModalOpen = _a.setModalOpen, nestedDrawerOpen = _a.nestedDrawerOpen, setNestedDrawerOpen = _a.setNestedDrawerOpen;
    return (React.createElement(Drawer, { open: isModalOpen, onOpenChange: function (e) { return setModalOpen(e, modalProps); }, closeButton: (React.createElement("div", { className: "dui-hidden md:dui-block dui-container dui-mx-auto dui-max-w-md dui-my-8" },
            React.createElement(Button, { className: 'dui-w-full', buttonType: "LINK_UNDERLINE", leftIcon: React.createElement(RxCross1, null), onClick: function () { return setModalOpen(false, modalProps); } }, "Close"))), nestedDrawer: {
            open: nestedDrawerOpen,
            onOpenChange: setNestedDrawerOpen,
            onClose: function () { return setNestedDrawerOpen(false); },
            children: modalProps === null || modalProps === void 0 ? void 0 : modalProps.nestedDrawerContent
        } },
        React.createElement("div", { className: "dui-p-4" }, modalProps.content)));
};
export default InfoDrawer;
